import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  logoutEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }
}
